const senderTypes = {
  HR: "hr",
  MB: "omb",
  AHR: "ahr",
  employee: "employee",
  notification: "notification",
};

export default senderTypes;
